export enum DistributionRestrictionType {
    UNKNOWN = 'UNKNOWN',
    CONTENT = 'CONTENT',
    VISUALS = 'VISUALS',
}
